export default __webpack_public_path__ + "c4c57361161ddb0af6b48f7fb31e0508.png";